import React, { useState, useEffect, useRef } from 'react';
import { BarcodeDetector } from 'barcode-detector/pure';
import { Icon } from '@mui/material';
import { getStoredSettings, storeSettings } from 'app/services/localStorageService';

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
//TODO: get both imeis and let him choose
const BarcodeScanner5 = ({ onDetected, open, onClose, qrPattern }) => {
  const [cameraStream, setCameraStream] = useState(null);
  const barcodeDetector = new BarcodeDetector({
    formats: ['code_128', 'linear_codes'],
  });
  const videoRef = useRef(null);
  const parentRef = useRef(null);
  const [detectedValues, setDetectedValues] = useState([]);
  const [devices, setDevices] = useState([]);
  const [started, setStarted] = useState(false);
  const [showPermissionPopup, setShowPermissionPopup] = useState(false);

  let detectedBarcodes = [];

  const handleClose = async () => {
    await close();
    onClose();
  };
  // const videoRef = useRef(null);

  const startStream = async (deviceId) => {
    // console.log('here', deviceId)
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: 'environment',
        // frameRate: 20,
        // height: 1000,
        width: { ideal: 1920 },
        height: { ideal: 1080 },
        aspectRatio: { ideal: 1.7777777778 },
        // @ts-ignore
        focusMode: { ideal: 'continuous' },
        deviceId: { ideal: deviceId ? deviceId : undefined },
      },
      audio: false,
    });

    setCameraStream(stream);
    await sleep(200);

    if (videoRef.current) {
      videoRef.current.srcObject = stream;
    }
  };

  const startCamera = async (device = '') => {
    try {
      setStarted(true);
      if (cameraStream) return;
      // setStarted(true)
      let deviceId = device;
      // navigator.permissions.query({ name: "camera" }).then((result) => {
      //   console.log(result.state);
      //   navigator.mediaDevices.getUserMedia({ video: true });
      //   // navigator.permissions
      // });
      const devices = await navigator.mediaDevices.enumerateDevices();
      const backCameras = devices.filter(
        (d) => d.kind === 'videoinput' && d.label.indexOf('back') >= 0,
      );
      if (backCameras.length > 0) {
        setDevices(backCameras);
      }
      // console.log(backCameras);
      await startStream(deviceId);
    } catch (err) {
      console.error('Error accessing camera:', err);
    }
  };

  // Function to stop the camera
  const stopCamera = () => {
    if (cameraStream) {
      console.log('in useeffect');
      const tracks = cameraStream.getVideoTracks();
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];
        console.log('track', track);
        cameraStream.removeTrack(track);
        track.stop();
      }

      setCameraStream(null);
    }
  };

  const stopTracks = () => {
    return new Promise((resolve, _) => {
      if (cameraStream) {
        let tracks = cameraStream.getVideoTracks();
        const tracksToClose = tracks.length;
        var tracksClosed = 0;
        cameraStream.getVideoTracks().forEach((videoTrack) => {
          cameraStream.removeTrack(videoTrack);
          videoTrack.stop();
          ++tracksClosed;
          if (tracksClosed >= tracksToClose) {
            if (videoRef?.current) {
              videoRef.current.srcObject = null;
            }

            setCameraStream(null);
            setTimeout(() => {
              resolve();
            }, 10);
          }
        });
      }
    });
  };

  const close = () => {
    // if (!open) {
    //     // Already closed.
    //     return Promise.resolve();
    // }

    return new Promise((resolve, _) => {
      if (cameraStream) {
        let tracks = cameraStream.getVideoTracks();
        const tracksToClose = tracks.length;
        var tracksClosed = 0;
        cameraStream.getVideoTracks().forEach((videoTrack) => {
          cameraStream.removeTrack(videoTrack);
          videoTrack.stop();
          ++tracksClosed;

          if (tracksClosed >= tracksToClose) {
            // $this.isClosed = true;
            // parentRef.current?.removeChild(videoRef.current as any);
            // videoRef.current?.remove()
            const videoElem = document.querySelector('video');
            if (videoElem) {
              console.log('element exists', videoElem);
              videoElem.pause();
              videoElem.removeAttribute('src');
              videoElem.src = '';
              videoElem.remove();
              console.log('element exists 2', videoElem);
            }
            setCameraStream(null);
            setTimeout(() => {
              const videoElem = document.querySelector('video');
              if (videoElem) {
                console.log('timeout element', videoElem);
              }

              console.log('resolve');
              resolve();
            }, 10);
          }
        });
      }
    });
  };

  // Function to detect barcode
  const detectBarcode = async () => {
    // setDebug('here')
    if (cameraStream && barcodeDetector) {
      const video = document.querySelector('video');
      try {
        const barcodes = await barcodeDetector.detect(video);

        // console.log(barcodes);
        // setDebug((video))
        if (barcodes.length > 0) {
          const detectedBarcode = barcodes[0].rawValue;
          // setBarcode(detectedBarcode);
          const regex = qrPattern || /^\d{15}$/; // Regex for 15 numbers
          if (regex.test(detectedBarcode) && !detectedValues.includes(detectedBarcode)) {
            detectedBarcodes.push(detectedBarcode);

            // console.log(detectedBarcode)
            await close();
            onDetected(detectedBarcode);
            // stopCamera();
            console.log(detectedBarcodes);
          }
          // if (detectedBarcodes.length === 2) {
          //   stopCamera();
          //   onDetected(detectedBarcodes);
          // }
        }
      } catch (err) {
        console.error('Error detecting barcode:', err);
      }
    }
  };

  useEffect(() => {
    // console.log('i fire once');
    const settingString = getStoredSettings();
    console.log(settingString);
    let settings;
    if (settingString) {
      settings = JSON.parse(settingString);
    }
    if (settings?.showed_camera_popup) {
      startCamera();
    } else {
      // navigator.permissions.query({ name: "camera" }).then((result) => {
      //   console.log(result.state);
      //   navigator.mediaDevices.getUserMedia({ video: true });
      //   // navigator.permissions
      // });
      setShowPermissionPopup(true);
      // storeSettings({showed_camera_popup: true})
      console.log('pop  up');
    }

    // startCamera();
    return () => stopCamera();
  }, []);

  // useEffect(() => {
  //   if (open) {
  //     startCamera();
  //   } else {
  //     stopCamera();
  //   }
  //   return () => stopCamera();
  // }, [open]);

  useEffect(() => {
    if (cameraStream) {
      const interval = setInterval(detectBarcode, 20);
      return () => clearInterval(interval);
    }
  }, [cameraStream]);

  if (showPermissionPopup) {
    console.log('here');
    return (
      <div className="fixed top-0 left-0 w-full h-full z-50 bg-white">
        <div className="flex flex-col justify-center items-center w-full h-screen">
          <div className="mb-2 text-lg">لطفا برای اسکن و دسترس به دوربین دکمه Allow رو بزنین</div>
          <div className="w-full flex justify-center">
            <img
              objectFit="contain"
              width={300}
              src="/assets/images/permission-popup.png"
              alt="permission-popup"
              onClick={() => {
                setShowPermissionPopup(false);
                startCamera();
                storeSettings({ showed_camera_popup: true });
              }}
            />
          </div>
        </div>
      </div>
    );
  }
  if (!started) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 w-full h-full z-50 bg-black">
      <div className="flex justify-center items-center h-screen " ref={parentRef}>
        <video
          autoPlay
          playsInline
          muted
          style={{ width: '100%', height: 'auto' }}
          ref={videoRef}
        />
        {devices && devices.length > 1 && (
          <div className="bg-white py-1 absolute bottom-0 left-0 right-0 flex justify-center items-center z-50 gap-2 mb-10">
            <div className="text-black text-sm">دوربین</div>
            <select
              className="text-black text-sm bg-transparent border-black border-2 rounded-md px-2 py-1"
              onChange={async (e) => {
                console.log(e.target.value);
                await stopTracks();
                // close()
                startStream(e.target.value);
              }}
            >
              {devices.map((d, i) => (
                <option key={i} value={d.deviceId}>
                  {d.label}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="text-white cursor-pointer absolute top-0 right-0" onClick={handleClose}>
          <Icon>cross</Icon>
        </div>
      </div>
    </div>
  );
};

export default BarcodeScanner5;
